import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "svgSource"]

  open() {
    this.modalTarget.classList.remove("hidden")
    this.modalTarget.classList.add("flex")
  }

  close() {
    this.modalTarget.classList.add("hidden")
    this.modalTarget.classList.remove("flex")
  }

  closeBackground(e) {
    if (e.target === this.modalTarget) this.close()
  }

  download() {
    const container = this.svgSourceTarget
    const svgEl = container.querySelector("svg")
    if (!svgEl) return

    const svgClone = svgEl.cloneNode(true)
    const viewBox = svgClone.getAttribute("viewBox")
    if (viewBox) {
      const [, , w, h] = viewBox.split(" ").map(Number)
      svgClone.setAttribute("width", w)
      svgClone.setAttribute("height", h)
    }

    const svgBlob = new Blob([svgClone.outerHTML], { type: "image/svg+xml;charset=utf-8" })
    const svgUrl = URL.createObjectURL(svgBlob)

    const svgImg = new Image()
    const loadSvg = new Promise((resolve) => {
      svgImg.onload = resolve
      svgImg.onerror = resolve
      svgImg.src = svgUrl
    })

    const imgEl = container.querySelector("img")
    let logoImg = null
    let loadLogo = Promise.resolve()
    if (imgEl) {
      logoImg = new Image()
      logoImg.crossOrigin = "anonymous"
      loadLogo = new Promise((resolve) => {
        logoImg.onload = resolve
        logoImg.onerror = resolve
        logoImg.src = imgEl.src
      })
    }

    Promise.all([loadSvg, loadLogo]).then(() => {
      URL.revokeObjectURL(svgUrl)

      const scale = 3
      const canvas = document.createElement("canvas")
      const svgSize = svgImg.naturalWidth
      canvas.width = svgSize * scale
      canvas.height = svgSize * scale
      const ctx = canvas.getContext("2d")
      ctx.scale(scale, scale)
      ctx.drawImage(svgImg, 0, 0)

      if (logoImg && logoImg.complete && logoImg.naturalWidth > 0) {
        const outerSize = Math.round(48 * svgSize / 260)
        const ox = (svgSize - outerSize) / 2
        const oy = (svgSize - outerSize) / 2

        ctx.fillStyle = "#ffffff"
        ctx.beginPath()
        ctx.roundRect(ox, oy, outerSize, outerSize, Math.round(outerSize * 0.2))
        ctx.fill()

        const innerMax = Math.round(36 * svgSize / 260)
        const aspect = logoImg.naturalWidth / logoImg.naturalHeight
        const [dw, dh] = aspect > 1
          ? [innerMax, innerMax / aspect]
          : [innerMax * aspect, innerMax]
        const dx = ox + (outerSize - dw) / 2
        const dy = oy + (outerSize - dh) / 2
        ctx.drawImage(logoImg, dx, dy, dw, dh)
      }

      canvas.toBlob((pngBlob) => {
        const pngUrl = URL.createObjectURL(pngBlob)
        const a = document.createElement("a")
        a.href = pngUrl
        a.download = "survey-qr.png"
        a.click()
        URL.revokeObjectURL(pngUrl)
      }, "image/png")
    })
  }
}
